<template>
  <div class="text-right"  :class="client == 'iOS' ? 'iosBox' : 'androidBox'">
    <div class="headBox">
      <header-top 
      :text="$t('withdrawalLogin.title')" 
      :historyBtn="true"
      :guildId = userGuildData.guildId
      :guildUid = userGuildData.guildUid
      :toUrl = userGuildData.appealToPlatformUrl
      ></header-top>
      <!-- <div class="head">
        <img :src="listData.icon" alt="" />
        <div class="txt">
          <div class="name">
            {{ listData.nickname }}
          </div>
          <div class="id">
            <span>ID</span> <span class="ids">{{ listData.userId }}</span>
          </div>
        </div>
      </div> -->
      <div class="pocket">
        <div class="pocket-txt">{{ $t('guild_can_with') }}</div>
        <div class="species">
          <img
            src="../../assets/h5/icon$.png"
            alt=""
          />
          <div>{{ userGuildData.currentCoin.toLocaleString('en-US')}}</div>
        </div>
      </div>
      <div class="pocket pocket-ing">
        <div class="pocket-txt">{{ $t('guild_with_ing') }}</div>
        <div class="species">
          <img
            src="../../assets/h5/icon$.png"
            alt=""
          />
          <div>{{ userGuildData.pendingCoin.toLocaleString('en-US')}}</div>
        </div>
      </div>
    </div>
    <div class="listBox">
      <!-- 选择国家 法语相关-->
      <!-- <div class="selectType">
        <div class="selectType_txt">选择提现方式</div>
        <div class="selectType_country">
            <div class="countryShowBox" :class="countryListShow ? 'activeCountryShowTitle' : ''"@click="changeCountryList(countryListIndex)">
              <img :src="countryList[countryListIndex].icon" alt="">
              <span :class="countryListShow ? 'countryName' : ''">{{ countryList[countryListIndex].name }}</span>
            </div>
            <div class="countryListBox" v-if="countryListShow">
              <div class="countryShowBox" :class="countryListIndex == index ? 'activeCountryShowBox' : ''" v-for="(item,index) in countryList" @click="changeCountryList(index)">
                <img :src="item.icon" alt="">
                <span>{{ item.name }}</span>
              </div>
            </div>
        </div>
      </div> -->
      <div class="select-box">
        <header v-if="!noPermission">{{ $t('guild_select_hand') }}</header>
        <ul class="select-list" v-if="!noPermission">
          <li class="select-item"  @click="$router.push({ 
            path: '/self-withdrawal', 
            query:{
                cin:userGuildData.currentCoin.toLocaleString('en-US'),
            }
            })">
            <div>
              {{ $t('guild_self_withdraw')  }}
            </div>
            <span></span>
          </li> 
          <li class="select-item"
          v-if="userGuildData.transferLeaderLimit == 1"
          @click="$router.push({ 
              path: '/to-guild-leader',
              query: { 
                cin:userGuildData.currentCoin,
                guildId:userGuildData.guildId,
                guildUid:userGuildData.guildUid,
                minCoin: userGuildData.transferToLeaderMinCoin,
                toUrl: userGuildData.appealToPlatformUrl
              }
              })">
            <div>
              {{ $t('guild_transfer_to_leader')  }}
            </div>
            <span></span>
          </li> 
          <li class="select-item" 
            v-if="userGuildData.transferResellerLimit == 1"
            @click="$router.push({ 
              path: '/to-reseller',
              query: { 
                cin:userGuildData.currentCoin.toLocaleString('en-US'),
                guildId:userGuildData.guildId,
                guildUid:userGuildData.guildUid,
                minCoin: userGuildData.transferToLeaderMinCoin
              }
              })">
            <div>
              {{ $t('guild_salary_to_reseller')  }}
            </div>
            <span ></span>
          </li> 
          <li class="select-item" 
          v-if="userGuildData.transferDiamondLimit == 1"
          @click="$router.push({ 
              path: '/to-diamond'
              })">
            <div>
              {{ $t('guild_convert_to_diamond')  }}
            </div>
            <span ></span>
          </li> 
          <li class="select-item" 
          v-if="userGuildData.settlementLimit == 1"
          @click="$router.push({ 
              path: '/to-platform',
              query: { 
                // minCoin: userGuildData.platformSettlementMinCoin,
                toUrl: userGuildData.appealToPlatformUrl
              }
              })">
            <div>
              {{ $t('guild_platform_settlement')  }}
            </div>
            <span></span>
          </li> 
        </ul>
      </div>
      <!-- 转移到单独页面 -->
      <template v-if="noPermission">
        <div class="index-list">
          <WithdrawalList></WithdrawalList>
        </div>
        <!-- <div class="list" v-for="item in listData.item" :key="item.id">
          <div v-if="item.id == 5 || item.id == 8 || item.id == 7 || item.id == 4 || item.id == 11 || item.id == 6 || item.id == 13 || item.id == 12 || item.id == 15 || item.id == 16">
            <div class="list-txt">{{ item.name }}</div>
            <div style="display:flex;flex-wrap: wrap;">
              <div
                class="list-box"
                v-for="Aitem in item.list"
                :key="Aitem.id"
                @click="channelBtn(item, Aitem)"
              >
                <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
                <div class="money-box">
                  <img
                    class="money-img"
                    src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
                    alt=""
                  />
                  <div class="money-num">{{ Aitem.usd }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="item.id == 10 || item.id == 9 ">
            <div class="list-txt">{{ item.name }}</div>
            <div style="display:flex;flex-wrap: wrap;">
              <div
                  class="list-box"
                  v-for="Aitem in item.list"
                  :key="Aitem.id"
                  @click="channelPixBtn(item, Aitem)"
              >
                <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
                <div class="money-box">
                  <img
                      class="money-img"
                      src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
                      alt=""
                  />
                  <div class="money-num">{{ Aitem.usd }}</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </template>
      
    </div>
    <van-popup
      v-model:show="show"
      closeable
      round
      position="bottom"
      :style="{ height: '20%' }"
      class="popup"
      >{{ $t("withdrawalLogin.Pocket") }}</van-popup
    >
    <!-- <div v-if="officialUrl" class="officialBox">
      <p>{{ $t("withdrawalLogin.officialGroup") }}</p>
      <p>
        <a href="#" @click.prevent.stop>{{ officialUrl }}</a>
      </p>
    </div> -->
    <div class="meta-box" v-if="loading">
          <van-loading
            type="spinner"
            color="#cccccc"
            size="20px"
          />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Toast,Popup,Loading } from "vant";
import HeaderTop from "@/components/withdrawal/top-header.vue"
import WithdrawalList from "@/components/withdrawal/withdrawal-list.vue"

export default {
  name: "App",
  components: {
    HeaderTop,
    WithdrawalList,
    VanPopup: Popup,
    [Loading.name]: Loading 
  },
  data() {
    return {
      client: 'PC',
      listData: {},
      token: "",
      uid: "",
      lang: "",
      show: false,
      deviceId: '',
      officialUrl:'',
      countryList:[
        {
          name:'Algeria',
          icon:require('@/assets/h5/country_a.png'),
          id:1
        },{
          name:'Belgium',
          icon:require('@/assets/h5/country_b.png'),
          id:2
        },{
          name:'Morocco',
          icon:require('@/assets/h5/country_m.png'),
          id:3
        },{
          name:'France',
          icon:require('@/assets/h5/country_f.png'),
          id:4
        }
      ],
      countryListShow:0,
      countryListIndex:0,
      loading:true,
      // 用户公会信息
      userGuildData:{
        guildId:100997,//公会ID
        guildUid:793228,//公会长uid
        currentCoin:0,//当前P币数
        pendingCoin:0,//提现中P币数
        transferLeaderLimit: 0, //转移给会长（0 没有权限，1 有权限） 
        transferDiamondLimit: 0, //薪资转钻石（0 没有权限，1 有权限）
        transferResellerLimit: 0, //转移给reseller（0 没有权限，1 有权限）
        settlementLimit: 0, //平台结算（0 没有权限，1 有权限）
        transferToLeaderMinCoin: 0,//转移给公会长最低提现数
        // platformSettlementMinCoin: 0, //平台结算最低提现数
        appealToPlatformUrl:'',//需要跳转的url  申诉页面地址
      }
    };
  },
computed: {
  noPermission() {
    return (this.userGuildData.transferLeaderLimit === 0 || this.userGuildData.transferLeaderLimit === undefined) && 
           (this.userGuildData.transferDiamondLimit === 0 || this.userGuildData.transferDiamondLimit === undefined) && 
           (this.userGuildData.transferResellerLimit === 0 || this.userGuildData.transferResellerLimit === undefined) && 
           (this.userGuildData.settlementLimit === 0 || this.userGuildData.settlementLimit === undefined);
  }
},

  created() {
    var ids = navigator.userAgent.match(
      /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
    );
    if (ids) {
      ids = ids[0];
    } else {
      ids = "Unknown Device";
    }
    try {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window["getUserInfo"] = (data) => {
        this.getUserInfo(data);
      };
    }catch(e){
      this.initUserData();
    }
    
    // this.contact();
    
     this.judgeClient();
  },
  mounted() {
    
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data)
      localStorage.setItem("data", JSON.stringify(this.userInfo));
      this.initUserData();
      this.getWhatsapp()
    },
    // 判断平台
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },
    // 展示国家列表
    changeCountryList(index=0){
      this.countryListShow = !this.countryListShow;
      this.countryListIndex = index;
    },  
    returnBtn() {
      if(this.$route.query.type == 1){
        this.$completes.complete("getPreviousPage");
      }else{
        this.$router.push("/withdrawalLogin");
      }
    },

    contact() {
      axios
        .get(this.$serviceIp +`/api/trade/card/tx/getInfoForWeb?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.listData = response.data.data;
            this.sortList(this.listData.item);
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        }).catch(()=>{

        }).finally(()=>{
          this.loading = false
        });
    },
    // 初始化用户信息
    initUserData(){
      this.initUserLangInfo()
      axios
        .get(this.$serviceIp +`api/trade/guild/withdraw/init?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'deviceId': this.deviceId,
                'version': '3.0',
                'lang': this.lang,
              }
        })
        .then(({data}) => {
          if (data.code == 200) {
            let newGuildInfoResult = data.data.newGuildInfoResult || {};
            this.userGuildData.currentCoin = data.data.currentCoin || 0
            this.userGuildData.pendingCoin = data.data.pendingCoin || 0
            this.userGuildData.guildId = newGuildInfoResult.id
            this.userGuildData.guildUid = newGuildInfoResult.userId
            this.userGuildData.transferLeaderLimit = newGuildInfoResult.transferLeaderLimit
            this.userGuildData.transferDiamondLimit = newGuildInfoResult.transferDiamondLimit
            this.userGuildData.transferResellerLimit = newGuildInfoResult.transferResellerLimit
            this.userGuildData.settlementLimit = newGuildInfoResult.settlementLimit
            this.userGuildData.transferToLeaderMinCoin = data.data.transferToLeaderMinCoin
            // this.userGuildData.platformSettlementMinCoin = data.data.platformSettlementMinCoin
            this.userGuildData.appealToPlatformUrl = data.data.appealToPlatformUrl
          } else {
            Toast(data.message || this.$t("transfer.error"));
          }
        }).catch(()=>{}).finally(()=>{
          this.loading = false
        });
    },
    initUserLangInfo(){
      let data = JSON.parse(localStorage.getItem("data"));
      this.token = data.token;
      this.uid = data.uid || data.userId;
      this.lang = data.lang || navigator.language;
      this.deviceId = data.deviceId || ids
      let langs = this.lang.substring(0, 2);
      if (langs == "zh") {
        if (this.lang == "zh-TW" || this.lang == "zh-HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr"
      } else if (langs == "id") {
        this.$i18n.locale = "id"
      } else if (langs == "ms") {
        this.$i18n.locale = "ms"
      } else {
        this.$i18n.locale = "en";
      }
      document.title = this.$t("withdrawalLogin.title");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
      if(data.uid){
        this.changeTime()
      }
    },
    // 获取官方群
    getWhatsapp() {
      axios
        .get(this.$serviceIp +`/api/trade/withdraw/whatsappForWeb?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'version': '3.0',
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
        })
        .then((response) => {
          if (response.data.code == 200) {
              this.officialUrl = response.data.data;
          }
        });
    },
    // 排序
    sortList(item){
      item.forEach(element => {
        element.list.sort((a, b) => {
          return a.sort - b.sort;
        });
      });
    },
    channelBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/withdrawalDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
                id:item.id,
                sabankList: JSON.stringify(response.data.data.sabankList) || ''
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },

    channelPixBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `/api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId,
                'lang': this.lang,
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/pixDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },

    changeTime() {
      let item = JSON.parse(localStorage.getItem("time"));
      if (item < Date.now()) {
        localStorage.removeItem("data");
        localStorage.removeItem("time");
        this.$router.push("/withdrawalLogin");
      }
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* .iosBox{
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top); 
} */
html[lang="ar"] .text-right{
  direction: rtl;
}
html[lang="ar"] .hound {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .head {
  direction: rtl;
}

html[lang="ar"] .pocket {
  direction: rtl;
}
html[lang="ar"] .list {
  direction: rtl;
}
html[lang="ar"] .txt {
  margin-right: 0.3rem;
}
html[lang="ar"] .species img {
  margin-left: 0.1rem;
}
html[lang="ar"] .select-item span{
  transform: rotateY(180deg);
}
html[lang="ar"] .select-item div::before{
  margin-left: 8px;
}
html[lang="ar"] .headBox{
  background: url('../../assets/withdrawal/headBg_ar.png') no-repeat;
  background-size: 100% 100%;

}
.selectType_country{
  width: 252px;
  height: 64px;
  position: relative;
}
.headBox{
  width: 100%;
  height: 480px;
  background: url('../../assets/withdrawal/headBg.png') no-repeat;
  background-size: 100% 100%;
}
.listBox{
  width: 100%;
  min-height: calc( 100vh - 434px);
  padding: 20px;
  box-sizing: border-box;
  border-radius: 24px 24px 0 0;
  margin-top: -100px;
  position: relative;
  background: #fff;
}

.countryShowBox{
  /* width: 176px; */
  height: 64px;
  border: 1px solid #eee;
  border-radius: 32px;
  display: flex;
  justify-content:start;
  align-items: center;
  padding-left: 16px;
}
.countryShowBox img{
  width: 32px;
  height: 32px;
  display: block;
  margin-right: 8px;
}
.countryShowBox span{
  width: 170px;
  font-size: 24px;
  line-height: 64px;
  font-weight: 500;
  color: #1f1315;
  position: relative;
}
.countryShowBox span::after{
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  background: url('../../assets/h5/downIcon.png') no-repeat;
  background-size: 100% 100%;
  vertical-align: middle;
  margin-left: 8px;
}
.countryName::after{
  transform: rotateX(180deg) translateY(50%)!important;
}
.countryListBox{
  margin-top: 10px;
  border-radius: 20px;
  box-shadow: 0px 2px 12px 0px #00000026;
  padding: 16px 0;
  background-color: #fff;
}
.countryListBox .countryShowBox span::after{
  display: none;
}
.countryListBox .countryShowBox span{
  /* width: 68px; */
   white-space: nowrap;        /* 不换行 */
  overflow: hidden;
  text-overflow: ellipsis; 
}
.countryListBox .countryShowBox{
  border: none;
}
.activeCountryShowBox{
  width: 90%;
  margin: 0 auto;
  background: #eee;
}
.activeCountryShowTitle{
  background: #F5F2FF;
}
.selectType{
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: space-between;
}
.selectType_txt{
  font-size: 28px;
  line-height: 64px;
  font-weight: 500;
  color: #1f1315;
}
.hound {
  width: 100%;
  height: 130px;
  display: flex;
  align-items: center;
  padding-top: 30px;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  box-sizing: border-box;
  position:relative;
}

.returns {
  /* width: 0.8rem;
  height: 0.8rem; */
  width: 28px;
  height: 28px;
  position: absolute;
}

.hound p {
  flex: 1;
  font-size: 30px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.text-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Mada';
}
.head {
  height: 0.95rem;
  width: 5.9rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
}

.head img {
  width: 0.96rem;
  height: 0.96rem;
  border-radius: 50%;
}
.txt {
  width: 2rem;
  height: 0.7rem;
  margin-left: 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.name {
  font-size: 0.27rem;
  font-family: Rubik;
  font-weight: 400;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.id {
  font-size: 0.24rem;
  font-family: Rubik;
  font-weight: 400;
  color: #acadbc;
}
.pocket {
  width: 5.9rem;
  height: 1rem;
  /* background: linear-gradient(180deg, #ffffff -6.39%, #fff2d0 100%); */
  border-radius: 12px;
  margin-top: 20px;
  padding: 0 0.34rem;
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  box-sizing: border-box;
}
.pocket-ing{
  margin-top:10px;
}

.pocket-txt {
  /* width: 1.5rem; */
  height: 30px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  margin-bottom: 8px;
}
.species {
  /* width: 1.24rem; */
  /* height: 0.44rem; */
  display: flex;
  align-items: center;
}

.species img {
  width: 34px;;
  height: 36px;
  margin-right: 0.1rem;
}

.species div {
  /* width: 0.73rem; */
  font-size: 36px;
  color: #fff;
  font-weight: 900;
}

.list {
  width: 600px;
  /* height: 1.9rem; */
  margin-bottom: 0.4rem;
}
.list .list-box:nth-of-type(3n+1) {
  margin-left: 0;
}
.list-box {
  width: 180px;
  min-height: 128px;
  margin-top: 0.3rem;
  margin-left: 22px;
  border-radius: 24px;
  /* border: 1px solid rgba(0, 210, 147, 1); */
  background: #f6f7f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}


.list-txt {
  height: 0.32rem;
  font-size: 0.27rem;
  font-family: Rubik;
  color: rgba(0, 0, 0, 1);
}

.money {
  width: 80%;
  min-height: 0.43rem;
  font-size: 0.37rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
}

.money-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.money-img {
  width: 0.27rem;
  height: 0.27rem;
}

.money-num {
  /* width: 0.6rem; */
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.24rem;
  color: rgba(128, 62, 57, 1);
  font-weight: 500;
  font-family: Rubik;
}
.popup {
  font-size: 0.24rem;
  color: #000000;
  font-weight: 500;
  font-family: Rubik;
  display: flex;
  justify-content: center;
  align-items: center;
}
.officialBox{
  margin-top: 30px;
  width: 590px;
  text-align: center;
  padding-bottom: 48px;
}
.officialBox p{
  font-size: 24px;
  font-weight: 500;
  color: #89848D;
  margin-bottom: 8px;
}
.officialBox p a{
  color: #4D70FF;
  font-size: 24px;
  font-weight: 600;
}
.meta-box{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
}
/* 公会结算新增 */
.select-box header{
  font-size: 28px;
  font-weight: 500;
  color: #1F1315;
}
.select-list{
  margin-top: 24px;
}
.select-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
   height: 68px;
   padding-bottom: 16px;
   border-bottom: 1px solid #F1F1F1;
   margin-bottom: 32px;
}
.select-item div{
  font-size: 28px;
  /* line-height: 36px; */
  font-weight: 500;
  color: #121212;
  display: flex;
  align-items: center;
}
.select-item div::before{
  content: "";
  width: 32px;
  height: 32px;
  background: url('../../assets/withdrawal/select-icon1.png') no-repeat;
  background-size: 100% 100%;
  margin-right: 8px;
}
.select-item:nth-of-type(2) div::before{
  background: url('../../assets/withdrawal/select-icon2.png') no-repeat;
  background-size: 100% 100%;
}
.select-item:nth-of-type(3) div::before{
  background: url('../../assets/withdrawal/select-icon3.png') no-repeat;
  background-size: 100% 100%;
}
.select-item:nth-of-type(4) div::before{
  background: url('../../assets/withdrawal/select-icon4.png') no-repeat;
  background-size: 100% 100%;
}
.select-item:nth-of-type(5) div::before{
  background: url('../../assets/withdrawal/select-icon5.png') no-repeat;
  background-size: 100% 100%;
}
.select-item span{
  width: 28px;
  height: 28px;
  background: url('../../assets/withdrawal/topage.png') no-repeat;
  background-size: 100% 100%;

}
</style>
<style>
.index-list .list-box {
  background: #F6F7F9;
}
</style>